import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { BackArrowIcon } from '@app-velocity/icons';
import { Box, Skeleton, StatusBackground } from '@app-velocity/ui';

import { SimpleStatus } from '@app-velocity/common';

import { HeaderLabel } from './HeaderLabel';

import { StatusBadge } from './StatusBadge';

const StyledHeader = styled('header')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  boxSizing: 'border-box',
  height: 56,
  width: '100%',
  color: '#fff',
  zIndex: 1,
  overflow: 'hidden',
  svg: {
    fill: '#fff',
  },
}));

const StyledBackArrowContainer = styled(Box)({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 'calc(var(--basic-grid) * 2)',
  fontWeight: 'var(--font-weight-regular)',
  fontSize: 'var(--font-size-regular)',
  lineHeight: 'var(--line-height-medium)',
  minWidth: 0,
});

const IconContainer = styled('div')({
  flex: '0 0 auto',
});

const LabelContainer = styled('div')({
  flex: 1,
  overflow: 'hidden',
});

const ContentContainer = styled('div')({
  flex: 1,
});

export type PageStatusHeaderProps = {
  status: SimpleStatus | null;
  label?: string;
  description?: ReactNode;
  onBack: () => void;
  image?: ReactNode;
  content?: ReactNode;
};

export const PageStatusHeader = ({
  status,
  label,
  description,
  image,
  onBack,
  content,
}: PageStatusHeaderProps) => {
  return (
    <StyledHeader>
      <StatusBackground status={status} />

      <StyledBackArrowContainer onClick={onBack}>
        <IconContainer>
          <BackArrowIcon />
        </IconContainer>

        {label ? (
          <LabelContainer>
            <HeaderLabel
              label={label}
              description={description}
              image={image}
            />
          </LabelContainer>
        ) : null}
      </StyledBackArrowContainer>
      {content ? <ContentContainer>{content}</ContentContainer> : null}
      {!status ? (
        <Skeleton height={24} borderRadius={1} margin="0" width={150} />
      ) : (
        <StatusBadge status={status} />
      )}
    </StyledHeader>
  );
};
